import React from 'react';
import {GatsbyImage, IGatsbyImageData} from "gatsby-plugin-image";
import useStyles from './PostCard.styles';
import {Anchor, Paper} from "@mantine/core";
import {graphql, Link} from "gatsby";

interface PostCardProps {
    post: Pick<Queries.ContentfulBlogPost, "title" | "slug"> & {
        featured_image: {
            title: string | null;
            gatsbyImageData: IGatsbyImageData | null;
        } | null
    }
}

const PostCard: React.FC<PostCardProps> = ({post}) => {
    const {classes} = useStyles();

    return (
        <div className={classes.card} key={post.slug}>
            <Anchor component={Link} to={post.slug || ''} className={classes.card_img_block}>
                {post.featured_image?.gatsbyImageData && (
                    <GatsbyImage className={classes.card_img_block_inner} image={post.featured_image.gatsbyImageData} alt={post.featured_image.title || ''}/>
                )}
            </Anchor>
            <div>
                <Paper><span className={classes.meta_date}>19 апреля 13:53</span></Paper>
                <div className={(classes.title)}>
                    <div>
                        <Anchor component={Link} to={post.slug || ''} className={classes.link}>{post.title}</Anchor>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PostCard;